import { AbyssIcon } from '@/assets/icons/AbyssIcon';

export const getIconNode = (iconName?: string | null, size: 'xs' | 'sm' | 'md' = 'md') => {
  if (!iconName) return null;

  return <AbyssIcon iconName={iconName} size={size} />;
};

export const getSubtitleIconNode = (iconName?: string | null) => {
  if (!iconName) return null;
  return getIconNode(iconName, 'xs');
};
